import { IPaginatedResponse, IResponse, ISearchRequest } from "..";
import client from "../client";
import { IUserShort } from "./project.service";

interface INewTeam {
  name: string;
  userId: string;
}

interface INewTeamInvite {
  targetEmail: string;
}

interface ITeamInvite {
  token: string;

  teamId: string;
  teamName: string;
  targetEmail: string;

  createdAt: string;
}

export interface ITeamMembership {
  inviteToken?: string;

  teamId: string;
  userId: string;
  role: string;

  user: IUserShort;
}

export interface ITeamMembershipAddRequest {
  inviteToken?: string;
  teamId: string;
  userId: string;
  role: string;
}

export interface ITeam {
  createdAt: string | number | Date;
  id: string;
  name: string;

  createdOn?: Date;
  updatedOn?: Date;
}

async function getTeams() {
  return client.get<IResponse<ITeam>>("/team");
}

async function getTeam(id: string) {
  return client.get<IResponse<ITeam>>(`/team/${id}`);
}

async function deleteTeam(id: string) {
  return client.delete<IResponse<any>>(`/team/${id}`);
}

async function getTeamMembers(id: string) {
  return client.get<IResponse<ITeamMembership[]>>(`/team/${id}/member`);
}

async function getMyTeam() {
  return client.get<IResponse<ITeam>>(`/team/my`);
}

async function addTeam(team: INewTeam) {
  return client.post<IResponse<ITeam>>(`/team`, team);
}

async function addMember(id: string, invite: ITeamMembershipAddRequest) {
  return client.post<IResponse<ITeamMembership>>(`/team/${id}/member`, invite);
}

async function removeMember(id: string, userId: string) {
  return client.delete<IResponse<ITeamMembership>>(
    `/team/${id}/member/${userId}`
  );
}

async function inviteMember(id: string, invite: INewTeamInvite) {
  return client.post<IResponse<ITeamInvite>>(
    `/team/${id}/member/invite`,
    invite
  );
}

async function verifyInvite(token: string) {
  return client.get<IResponse<ITeamInvite>>(`/invite/${token}`);
}

async function searchTeams(req: ISearchRequest) {
  return client.post<IPaginatedResponse<ITeam[]>>("/team/search", req);
}

const api = {
  getTeams,
  getTeam,
  addTeam,
  deleteTeam,
  getMyTeam,
  getTeamMembers,
  inviteMember,
  verifyInvite,
  addMember,
  searchTeams,
  removeMember,
};

export default api;
